import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { OverlayDirective } from '../../shared/overlay/overlay.directive';
import { SharedVariablesService } from '../../shared/shared-variables/shared-variables.service';
import { FormatDatePipe } from '../../table/pipes/format-date.pipe';

@Component({
  selector: 'pozi-app-info',
  imports: [OverlayDirective, FormatDatePipe, NgOptimizedImage],
  templateUrl: './app-info.component.html',
  styleUrl: './app-info.component.scss',
})
export class AppInfoComponent {
  private sharedVars = inject(SharedVariablesService);

  build = environment.about;
  apiBuild: { buildDate: string; version: string };

  constructor() {
    this.apiBuild = this.sharedVars.getVar('apiVersion');
  }
}
